import React from "react";
import { useUserStore } from "../../store/userStore";
import SalesDashboard from "../salesDashboard/dashboard/Dashboard";
import Dashboard from "../dashboard/Dashboard";

const RoleDashboard = () => {
  const userDetails = useUserStore((state) => state.userDetails);
  const isSales = userDetails?.department === "Sales";
  console.log("isSales", userDetails);
  if (isSales) return <SalesDashboard />;

  return <Dashboard />;
};

export default RoleDashboard;
